import Vue from 'vue';
import { email, required, not, sameAs, } from 'vuelidate/lib/validators';
import FormFieldWrapper from '@/forms/FormFieldWrapper.vue';
import { $httpChangiRecommends } from '@/core/api';
import { mapMutations } from 'vuex';
const customPassword = (value) => value.length >= 8 &&
    /\d/.test(value) &&
    /[a-z]/.test(value) &&
    /[A-Z]/.test(value) &&
    /[!@#\$%\^\&*\)\(+=._-]/.test(value);
export default Vue.extend({
    components: { FormFieldWrapper },
    data() {
        return {
            isLoading: false,
            apiErrors: {},
            form: {
                email: '',
                name: '',
                password: '',
                passwordConfirm: '',
            },
            title: 'Sign up',
            passwordValidator: {
                has_minimum_lenth: false,
                has_number: false,
                has_lowercase: false,
                has_uppercase: false,
                has_special: false,
                has_different: false,
            },
        };
    },
    validations: {
        form: {
            email: {
                email,
                required,
            },
            name: {
                required,
            },
            password: {
                required,
                notSameAsEmail: not(sameAs('email')),
                customPassword,
            },
            passwordConfirm: {
                required,
                sameAsPassword: sameAs('password'),
            },
        },
    },
    watch: {
        'form.password': function () {
            this.passwordValidator.has_minimum_lenth = this.form.password.length >= 8;
            this.passwordValidator.has_number = /\d/.test(this.form.password);
            this.passwordValidator.has_lowercase = /[a-z]/.test(this.form.password);
            this.passwordValidator.has_uppercase = /[A-Z]/.test(this.form.password);
            this.passwordValidator.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.form.password);
            this.passwordValidator.has_different =
                this.form.password !== this.form.email;
        },
    },
    methods: {
        ...mapMutations('userModule', ['setUser']),
        onSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.isLoading = true;
            const { email, name, password, passwordConfirm } = this.form;
            const registerData = {
                email,
                name,
                password,
                password_confirmation: passwordConfirm,
            };
            $httpChangiRecommends.api
                .register(registerData)
                .then(({ data }) => {
                this.$emit('registerSuccess');
                // this.setUser(data);
            })
                .catch(({ data }) => {
                const { errors } = data;
                if (!errors) {
                    return;
                }
                this.apiErrors = {
                    password: errors?.password || [],
                    email: errors?.email || [],
                };
            })
                .finally(() => (this.isLoading = false));
        },
        clearApiErrors(formControlName) {
            this.apiErrors[formControlName] = [];
        },
    },
});
